import {Component, Input, OnInit} from '@angular/core';
import {LangProductMapper} from "../../../utils/lang-mappers";
import * as LessonsV3 from "../../../model/v3/lessons";

@Component({
    selector: 'app-progress-card-short',
    templateUrl: './progress-card-short.component.html',
    styleUrls: ['./progress-card-short.component.scss'],
    standalone: false
})
export class ProgressCardShortComponent implements OnInit {
   private _langCode: string
   private _progress: LessonsV3.ColCourseContext
  @Input()
  set langCode(lang: string) {
    this._langCode = lang
  }
  get langCode() {
   return this._langCode
  }
  @Input()
  set progress(progress: LessonsV3.ColCourseContext) {
    this._progress = progress
  }
  get progress() {
   return this._progress
  }

  constructor() {}

  ngOnInit(): void {}

  getCourseName() {
    return LangProductMapper.mapLangCodeToLangName(this.langCode);
  }

  getCourseClass() {
    if (this.langCode === 'en.bs') return 'course-enbus';
    if (this.langCode === 'en.ch') return 'course-encfk';
    return `course-${this.langCode}`;
  }

  getStage() {
     if (this.langCode === 'en.bs') return '';
     const courseCode = this.progress?.course?.code ?? '';
     const match = courseCode.match(/\.s(1[0-2]|[1-9])$/);
     if (!match) return '';
     return `Stage ${match[1]}`;
  }

  getProgress() {
    return this.progress.lessonsProgress
      ? this.progress.lessonsProgress * 100
      : 0;
  }
}
